import { ref, watch } from 'vue';

export default function useColumnVisibility(resource, type, columnsRef) {
    const visibleColumns = ref([]);
    const toggleableColumns = ref([]);
    const columnVisibilityInitialized = ref(false);

    function onToggleColumns(selected) {
        visibleColumns.value = columnsRef.value.filter(col =>
            !col.toggleable || selected.some(sel => sel.field === col.field)
        );
        localStorage.setItem(`visibleColumns_${resource}_${type}`, JSON.stringify(
            selected.map(col => col.field)
        ));
    }

    function setColumnVisibilityFromCache() {
        const stored = localStorage.getItem(`visibleColumns_${resource}_${type}`);
        if (stored && visibleColumns.value.length && !columnVisibilityInitialized.value) {
            const selectedFields = JSON.parse(stored);
            visibleColumns.value = columnsRef.value.filter(col =>
                !col.toggleable || selectedFields.includes(col.field)
            );
        }
        columnVisibilityInitialized.value = true;
    }

    // Whenever `columnsRef` changes (i.e. response came back), compute toggleableColumns
    watch(columnsRef, () => {
        toggleableColumns.value = columnsRef.value.filter(col => col.toggleable);
        // also set a default for visibleColumns (all columns) if not yet initialized
        if (!columnVisibilityInitialized.value) {
            visibleColumns.value = columnsRef.value;
        }
    }, { immediate: true });

    return {
        visibleColumns,
        toggleableColumns,
        onToggleColumns,
        setColumnVisibilityFromCache
    };
}
